(() => {
  'use strict';

  if (window.__choicesPhotoRetryFix) return;
  window.__choicesPhotoRetryFix = true;

  const REVIEW_MARKER = '3d7831f63beb4591c1c5d710471677946654e9eef32e599d';
  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    try {
      const rawUrl = typeof input === 'string' ? input : input?.url;
      if (rawUrl) {
        const url = new URL(rawUrl, location.origin);
        if (url.pathname === '/apps/choices-try-on/generate') {
          url.searchParams.set('choices_review_marker', REVIEW_MARKER);
          if (typeof input === 'string') input = url.pathname + url.search;
          else input = new Request(url.href, input);
        }
      }
    } catch (_error) {}
    return nativeFetch(input, init);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-choose-another]');
    if (!button) return;

    const widget = button.closest('choices-try-on');
    const input = widget?.fileInput || widget?.querySelector('input[type="file"]');
    if (!widget || !input) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      if (typeof widget.reset === 'function') {
        widget.reset();
      } else {
        widget.file = null;
        input.value = '';
        widget.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.panel !== 'upload';
        });
      }
    } catch (_error) {
      widget.querySelectorAll('[data-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.panel !== 'upload';
      });
    }

    widget.querySelectorAll('.has-error').forEach((node) => node.classList.remove('has-error'));
    widget.querySelectorAll('[data-error], .choices-profile__field-error, .choices-profile__error-summary').forEach((node) => {
      node.hidden = true;
      if (node.matches('[data-error]')) node.textContent = '';
    });

    input.value = '';
    input.click();
  }, true);
})();
